import LensunHeader from "../../header/lensun/headerlensun"

function Glitter(){
    return(
        <div>
            <LensunHeader />
        <section className="fotos">
        <div class="container px-4 px-lg-5 mt-5">
            <div class="row gx-4 gx-lg-5 row-cols-2 row-cols-md-3 row-cols-xl-4 justify-content-center">
                <div class="col mb-5 row-25">
                  <div className="principal"> 
                    <div class="card h-100">
                        <img  src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/back%2Fglitter%2FBACK%20WCU-GLITER%20RAINBOW.jpg?alt=media&token=c54c5d4d-91b0-49fd-8f6e-02ec104ab7b7" /> 
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">KJ021</h5>
                            </div>
                           </div>
                         
                    </div>
                </div>
              </div>
                <div class="col mb-5">
                <div className="principal">
                    <div class="card h-100">
                        <img src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/back%2Fglitter%2FBACK%20GLITER%20SILVER.jpg?alt=media&token=06ce2764-d7f6-4e62-b0d3-1163c33e99d6" />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">MR027</h5>
                            
                           </div>
                        </div>
                       </div>
                       
                    </div>
                </div>
                
                <div class="col mb-5">
                  <div className="principal"> 
                    <div class="card h-100">
                        <img  src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/back%2Fglitter%2FBACK%20GLITER%20RED.jpg?alt=media&token=5e07a154-f184-46bf-a47e-2cf6ac105c60" alt="..." /> 
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">DW041 </h5>
                           
                           </div>
                        </div>
                        </div>  
                        
                    </div>
                </div>
                <div class="col mb-5">
                <div className="principal">
                    <div class="card h-100">
                        <img  src="https://firebasestorage.googleapis.com/v0/b/lensuncaba.appspot.com/o/back%2Fglitter%2FBACK%20GLITER%20PINK.jpg?alt=media&token=d34119b0-b194-49a9-b764-d399a9dd9b93" alt="imagen de back" />
                        <div class="card-body p-4">
                          <div class="text-center">
                            <h5 class="fw-bolder">DY036 </h5>
                            
                           </div>
                        </div>
                       </div>
                       
                    </div>
                </div>
                </div>
                </div>
      </section>
        </div>
    )
}

export default Glitter




